<template>
    <section class="sidebarFilter">
        <div class="sidebarFilter__wrapperRadioButton">
            <label class="sidebarFilter__container">
                <input
                    id="relevance"
                    :checked="checkSortRelevance"
                    :value="sortOptions[0].value"
                    data-gtm="sidebarFilter__sort--relevance"
                    type="radio"
                    class="sidebarFilter__input"
                    @click="selectSort(sortOptions[0].name)" />
                <span class="sidebarFilter__radioButton"></span>
                {{ sortOptions[0].name }}
            </label>
            <label class="sidebarFilter__container">
                <input
                    id="publicationDate"
                    class="sidebarFilter__input"
                    data-gtm="sidebarFilter__sort--publicationDate"
                    :checked="checkSortPublicationDate"
                    :value="sortOptions[1].value"
                    type="radio"
                    @click="selectSort(sortOptions[1].name)" />
                <span class="sidebarFilter__radioButton"></span>
                {{ sortOptions[1].name }}
            </label>
            <!-- Will be added later -->
            <!--<label class="sidebarFilter__container">
                <input
                    :id="'popularity'"
                    :data-gtm="'sidebarFilter__sort&#45;&#45;popularity'"
                    :checked="checkSortPopularity"
                    :value="sortOptions[2].value"
                    type="radio"
                    tabindex="0"
                    @keyup.enter="selectSort(sortOptions[2].name)"
                    @click="selectSort(sortOptions[2].name)" />
                <span class="sidebarFilter__radioButton"></span>
                {{ sortOptions[2].name }}
            </label>-->
        </div>
    </section>
</template>

<script>
    import Translator from 'tools/trans';
    import { useGetters } from 'composables/useVuex';
    export default {
        name: 'SortFilter',
        data() {
            return {
                relevance: this.trans('FORM_SEARCH_RELEVANCE'),
                publicationDate: this.trans('FORM_SEARCH_DATE'),
                //popularity: this.trans('FORM_SEARCH_POPULARITY'),
                checkSortRelevance: '',
                checkSortPublicationDate: '',
                //checkSortPopularity: '',
                currentSort: this.sortOption,
                sortOptions: [
                    { value: 'idrelevance', name: this.trans('FORM_SEARCH_RELEVANCE') },
                    { value: 'publicationDate', name: this.trans('FORM_SEARCH_DATE') },
                    /*{ value: 'popularity', name: this.trans('FORM_SEARCH_POPULARITY') },*/
                ],
            };
        },
        methods: {
            trans: Translator.trans,
            selectSort(value) {
                if (value === this.relevance) {
                    this.checkSortRelevance = true;
                    this.checkSortPublicationDate = false;
                    //this.checkSortPopularity = false;
                    this.$emit('selected-sort-config', { value: this.relevance, param: 'idrelevance' });
                } else if (value === this.publicationDate) {
                    this.checkSortPublicationDate = true;
                    this.checkSortRelevance = false;
                    //this.checkSortPopularity = false;
                    this.$emit('selected-sort-config', { value: this.publicationDate, param: 'publicationDate' });
                } /*else if (value === this.popularity) {
                    this.checkSortPopularity = true;
                    this.checkSortRelevance = false;
                    this.checkSortPublicationDate = false;
                    this.$emit('selected-sort-config', { name: this.popularity, value: 'popularity' });
                }*/
            },
        },
        mounted() {
            if (this.sort === 'publicationDate') {
                this.checkSortPublicationDate = true;
            } else {
                this.checkSortRelevance = true;
            }
            /*else if (this.sort === 'popularity'){
                this.checkSortPopularity = true;
            }*/
        },
        setup() {
            const getters = {
                ...useGetters('search', [
                    'sort',
                ]),
            };

            return {
                ...getters,
            };
        },
    };
</script>
